export const MAX_RESCHEDULE_COUNT = 20;